import { Stack } from "@mantine/core";
import { PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import { FC } from "react";
import { useTableParams } from "utils/hooks/common/useTableParams";
import BankAccountActions from "./components/BankAccountActions/BankAccountActions";
import BankAccountTable from "./components/BankAccountTable/BankAccountTable";

const BANK_ACCOUNT_PAGE_TITLE = "Quản lý Tài khoản ngân hàng";

const BankAccountWebLayout: FC = () => {
  const { params, handlePageChange, handleLimitChange, handleSearch } =
    useTableParams();

  return (
    <Stack gap="sm">
      <PageHeader breadcrumbs={[{ title: BANK_ACCOUNT_PAGE_TITLE, href: "" }]} />
      <PageContent>
        <Stack gap="xs">
          <BankAccountActions handleSearch={handleSearch} params={params} />
          <BankAccountTable
            params={params}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
          />
        </Stack>
      </PageContent>
    </Stack>
  );
};

export default BankAccountWebLayout;
